import React from "react";

export default function Pattern4({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="113"
      height="443"
      viewBox="0 0 113 443"
      className={className}
    >
      <defs>
        <rect id="pattern4rect" width="113" height="443" x="0" y="0" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="rotate(180 56.5 221.5)">
        <mask id="pattern4mask" fill="#fff">
          <use xlinkHref="#pattern4rect" />
        </mask>
        <path
          fill="currentColor"
          d="M780.801015,-246 L788,-238.801015 L100.509107,444 L98,441.490893 L780.801015,-246 Z M751.023018,-246 L758,-239.020799 L70.3256607,444 L68,441.676558 L751.023018,-246 Z M720.250335,-245 L727,-238.250357 L40.1013734,444 L38,441.896417 L720.250335,-245 Z M690.434611,-245 L697,-238.434611 L9.88247731,444 L8,442.117523 L690.434611,-245 Z M659.616132,-245 L666,-238.620566 L1.8448692,421 L0,419.155131 L659.616132,-245 Z M629.834225,-245 L636,-238.834247 L1.84596064,391 L0,389.154046 L629.834225,-245 Z M599.059848,-245 L605,-239.062065 L1.84410674,360 L0,358.155893 L599.059848,-245 Z M569.244788,-245 L575,-239.24481 L1.84521628,330 L0,328.154791 L569.244788,-245 Z M539.460471,-245 L545,-239.458297 L1.8465097,300 L0,298.153505 L539.460471,-245 Z M508.686382,-245 L514,-239.690815 L1.84435972,269 L0,267.15564 L508.686382,-245 Z M478.908626,-245 L484,-239.908626 L1.84576177,239 L0,237.154238 L478.908626,-245 Z M449.086527,-245 L454,-240.086527 L1.84727038,209 L0,207.15273 L449.086527,-245 Z M418.279775,-244 L423,-239.279775 L1.84463465,179 L0,177.155365 L418.279775,-244 Z M388.495003,-245 L393,-240.492809 L1.84638319,148 L0,146.153627 L388.495003,-245 Z M357.726215,-244 L362,-239.726215 L1.84333286,118 L0,116.156667 L357.726215,-244 Z"
          mask="url(#pattern4mask)"
        />
      </g>
    </svg>
  );
}
